import { ApiSlice } from "./api.slice";

export const {
  useGetProjectsQuery,
  useGetProjectDetailsQuery,
  useGetProjectPackagesQuery,
  useGetPackageDetailsQuery,
  useGetPackageNotificationsQuery,
} = ApiSlice;
